import React, { useState } from 'react';
import { Stack, Typography, Icon, Space, Button } from 'witmeg-ui-system';
import "../styles/defaultStyles.scss"
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import "@fontsource/inter";
import "@fontsource/plus-jakarta-sans";
import RetailCartSummary from '../../../../common/RetailCartSummary';
import { getCurrencyFormat, isECommerceProcessPath, LOCAL_STORAGE_ITEMS_NAMES } from '../../../RestaurantWidget/utilities/helper/helper';
import { deleteCart, deleteCartItem, getCartItemsToCartV3, updateCartItemQuantity } from '../../../RestaurantWidget/utilities/api/restaurantsService';
import DeletePopup from './DeletePopup';
import { setOrderCartItems, setOrderData, setOrderEmpty, setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import editIc from "../../assets/edit.svg"
import deleteIc from "../../assets/trash.svg"
import closeIc from "../../assets/close.svg"
import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'

const CartPopup = ({ toggleVisibility, updateCartItemCallback, websiteType }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")

    const history = useHistory();
    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const retailDataState = useSelector((state) => state.retailData);

    const selectedOrderTypeOriginal = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const selectedOrderType = websiteType === "Restaurant" ? selectedOrderTypeOriginal : "retail"
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    const isRetailCartAvailable = retailDataState.cart && retailDataState.cart.length > 0 ? true : false

    const isButtonsDisabled = !isCartDataAvailable || isECommerceProcessPath();

    const isOrderSuccessPage = window.location.pathname.split('/')[1] === 'order-success' ? true : false;
    const currencyFormat = getCurrencyFormat(restaurantDataState.currency);
    const onCheckoutClick = () => {
        history.push('/checkout');
        toggleVisibility();
    };
    const handleOrdertype = () => {
        let type = "delivery"
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                type = "delivery";
                break;
            case "DINE_IN":
                type = "table";
                break;
            case "TAKE_AWAY":
                type = "collection";
                break;
            default:
                type = "delivery";
                break;
        }
        dispatch(setSelectedOrderType(type))
    }
    const onCheckoutClickRestaurant = () => {
        handleOrdertype()
        history.push('/order/checkout');
        toggleVisibility();
    };
    const onContinueShoppingClick = () => toggleVisibility();
    const showCartDetails = () => {
        toggleVisibility();
        history.push('/cart')
    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsLoading(item.ID)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsLoading("")
        })
    }
    const decreaseQty = (item) => {
        setIsLoading(item.ID)

        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsLoading("")

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsLoading("")
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const deleteCartAll = () => {
        setIsLoading("00000")
        dispatch(setOrderCartItems([]))
        deleteCart().then((response) => {
            if (response) {
                dispatch(setOrderEmpty())
                onContinueShoppingClick()
                setIsLoading("")


            } else {
                setIsLoading("")
            }
        })
    }


    const getPrice = (
        baseTotalPrice
    ) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
            case "table":
                priceValue = baseTotalPrice.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = baseTotalPrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }

    const getCartTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Net?.Formatted ?? "£ 0.00"

    }
    const getRestaurantComponent = () => {
        return (
            <>
                <div className="eco-mt-36">
                    <Stack horizontalAlign="space_between" className="sub-total-contianer">
                        <div type="text" pattern="bold" className="sub-total-label">Sub Total</div>
                        <div type="text" pattern="bold" className="sub-total">
                            {isLoading !== "" ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "35px" }}>XXXXXXXXXX</div> : getCartTotal()}
                        </div>
                    </Stack>
                    <div className={isCartDataAvailable ? 'rest-btn-conatiner' : 'rest-btn-conatiner-disable '}>
                        <div className="checkout-button" onClick={() => {
                            if (isCartDataAvailable) {
                                if (isLoading === "") {
                                    onCheckoutClickRestaurant()
                                }
                            }

                        }} >
                            Check Out
                        </div>
                        <div className="continue-shopping-button" onClick={onContinueShoppingClick}>
                            Continue Shopping
                        </div>
                    </div>
                </div>

            </>
        )
    }
    const getOtherComponent = () => {
        return (
            <div className="eco-mt-24">
                <Stack
                    horizontalAlign="space_between" className="eco-order-summary-row">
                    <Typography type="text" className="eco-order-summary-label">VAT</Typography>
                    <Typography type="text" pattern="bold" className="eco-order-summary-total">
                        {/* {currencyFormat(isCartDataAvailable ? restaurantDataState.cartDetails.total[selectedOrderType]?.vatAmount : 0)} */}
                    </Typography>
                </Stack>
                <Stack horizontalAlign="space_between" className="eco-order-summary-total-row">
                    <Typography type="text" pattern="bold" className="eco-order-summary-total-label">Total:</Typography>
                    <Typography type="text" pattern="bold" className="eco-order-summary-total-bg">
                        {retailDataState.cart.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.productDetails.SellingPricesArray.SellingPrice * currentItem.quantity;
                        }, 0)}
                    </Typography>
                </Stack>
                <>
                    <Button fullWidth variant="primary" className="eco-mb-12 eco-checkout-button" onClick={onCheckoutClick} disabled={!isRetailCartAvailable}>
                        Check Out
                    </Button>
                    <Button fullWidth variant="outline" className="eco-mb-12 eco-continue-shopping-button" onClick={showCartDetails} disabled={isOrderSuccessPage}>
                        View Cart
                    </Button>
                </>

            </div>)
    }

    return (
        <div className='voucher-cart-popup'>

            <>
                <div className="eco-product-list">

                    <div className='cart-header'>
                        <div className='cart-header-conat'>
                            <div className='cart-title'>Cart</div>
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 && <div className='cart-items-count'>{restaurantDataState.orderCartData.Items.length} item{restaurantDataState.orderCartData.Items.length === 1 ? "" : "s"}</div>
                            }
                        </div>
                        <img alt='' src={closeIc} className='close-icon ' onClick={() => { toggleVisibility() }} />
                        {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 1 && <div className="clear-button" onClick={() => {

                            deleteCartAll()



                        }} >
                            Clear All
                        </div>}

                    </div>
                    {websiteType === "Restaurant" ?
                        <>
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 ? restaurantDataState.orderCartData.Items.map((item, index) => (
                                <Stack className="eco-mb-20 " verticalAlign="v_start">
                                    <Typography
                                        style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: !item.PictureURL === "" ? "fill" : "" }}
                                        className="cart-item-image">
                                    </Typography>
                                    <div className='item-details-container'>
                                        <div className='item-details-container-left'>
                                            <div className='item-cart-title truncate-text'>{item.Title}</div>
                                            <div className='item-cart-price'>        {isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>{getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                                : getPrice(item.PriceInfo.TotalPrice)}</div>
                                        </div>

                                        <div className='item-details-container-right'>
                                            {isLoading === item.ID ?
                                                <div style={{ marginTop: "-8px" }}><Space > <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "35px" }}>XXXXXXXXXXXXXXXXXXX</div></Space></div> : <>
                                                    <div className='item-cart-qty-container'>
                                                        <div className='quantity-ic-cont' onClick={() => {
                                                            decreaseQty(item)
                                                        }}> <Icon name="minus" className="quantity-ic" size={16} /></div>
                                                        <div className='qty-cont'> {item.Quantity.Amount}</div>
                                                        <div className='quantity-ic-cont' onClick={() => {
                                                            increaseQty(item)
                                                        }}> <Icon name="plus" className="quantity-ic" size={16} /></div>
                                                    </div>
                                                    <div className='cart-action' onClick={() => {
                                                        setIsDeleteItem(item.ID)
                                                    }}> <img alt='' src={deleteIc} /></div>
                                                </>}
                                        </div>
                                    </div>
                                </Stack>
                            )) :
                                <Stack className="item eco-mb-16 eco-mt-16" style={{ display: "flex", justifyContent: "center" }}>
                                    <div>No cart items</div>
                                </Stack>

                            }
                        </>
                        : <div>
                            <RetailCartSummary />
                        </div>
                    }
                </div>
                {websiteType === "Restaurant" ? getRestaurantComponent() : getOtherComponent()}
            </>
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
        </div>
    );

}
export default CartPopup